module.exports = __webpack_public_path__ + "produce-fresh-grass-18.jpg?d9d54b1ad73236ca09445ae6d0f1af44";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produce-fresh-grass-18.jpg
// module id = 55
// module chunks = 0